export const prepareQueryParams = (
  params: any,
  settings: any = {},
  includedOptionalFilters: any = [],
  excludesParams: any = [],
) => {
  if (!params || !Object.keys(params)?.length) {
    return ''
  }

  const query = new URLSearchParams()

  Object.entries(params).forEach(([k, v]: any) => {
    if (
      !includedOptionalFilters.includes(k) &&
      settings?.optionalFilters?.includes(k)
    ) {
      return
    }

    if (excludesParams.includes(k)) {
      return
    }

    if (Array.isArray(v)) {
      v.forEach((vv) => query.append(k, vv))
    } else query.append(k, v)
  })

  return `?${query.toString()}`
}
